export default __webpack_public_path__ + "static/media/DigitalMicroscopeImg.a79bfbec.jpg";